import Vue from 'vue'

const EVENTS = Object.freeze({
  ERROR: 'ERROR',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  ROUTEUPDATE: 'ROUTEUPDATE',
  CLEAN_SEARCH_INPUT: 'CLEAN_SEARCH_INPUT',
  OPEN_SEARCH_PANEL: 'OPEN_SEARCH_PANEL',
  CLOSE_SEARCH_PANEL: 'CLOSE_SEARCH_PANEL',
  START_RESEARCH: 'START_RESEARCH',
  INIT_SEARCH_PANEL: 'INIT_SEARCH_PANEL',
  INIT_GOOGLE_API: 'INIT_GOOGLE_API',
  LOADING: 'LOADING',
  RESIZE_TABLE: 'RESIZE_TABLE',
  DOCUMENT_LOADED: 'DOCUMENT_LOADED',
  LOAD_DOCUMENT: 'LOAD_DOCUMENT',
  SUBMIT_MODAL: 'SUBMIT_MODAL',
  LINK_SIGNATURE: 'LINK_SIGNATURE',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  RELOAD: 'RELOAD',
  UPDATE_ADV_PROCEDURE: 'UPDATE_ADV_PROCEDURE',
  NEW_REMINDER: 'NEW_REMINDER',
  UPDATE_REMINDER: 'UPDATE_REMINDER',
  NEW_OPTION: 'NEW_OPTION',
  UPDATE_OPTION: 'UPDATE_OPTION',
  DELETE_REMINDER: 'DELETE_REMINDER',
  ADV_PROCEDURE_ERROR: 'ADV_PROCEDURE_ERROR',
  NEW_ADV_PROCEDURE: 'NEW_ADV_PROCEDURE',
  UPDATE_ADF_LRE: 'UPDATE_ADF_LRE',
  DELETE_ADF_LRE: 'DELETE_ADF_LRE',
  NEW_ADF_LRE: 'NEW_ADF_LRE'
})

const bus = new Vue()
export { bus, EVENTS }



// WEBPACK FOOTER //
// ./src/services/bus/index.js